/**
 * Provides premium apps uppsell functionality and support
 *
 * Internal mechanics notes:
 * - config.layerOptions can be overwritten by the openLayer config param
 * - the layer is created and destroyed every time it opens and closes
 * - this system only listens for sendMessage messages while the layer is open
 * - uses the 'revealing module' pattern
 * - the options for opening a modal = {
 *      title: 'the title of the dialog popup',
 *      layerOptions: { //overwrite some of the dialog options
 *          width:
 *          height:
 *      },
 *      onClose: function(loopBackParams){} //function to be called when the dialog closes
 *      loopBackParams: {}, //sent back untouched to the close callback
 * }
 *
 * @author mcojoc
 * @date: 2013
 */
var $ = require('jquery');
var crossDomain = require('diy/external/crossDomain');

(function () {
    'use strict';

    var layerIsOpen = false;

    var config = {
        //layerOptions are overwritable inside the openLayer
        layerOptions: {
            width: 800,
            height: 400,
            //title: only set in the openLayer options, there is not default value
            title: ''
        },
        //layer config (diy_dialog) but do not allow these to be overwritten
        immutableLayerOptions: {
            //zindex: needs to be above the site-admin
            zIndex: 100116,
            modal: true,
            closeButton: true,
            draggable: false,
            resizable: false
        },
        selectors: {
            //layerClass, value links appUpsell.css
            layerClass: 'appUpsellLayer'
        }
    };
    //hold some temp variables
    var registry = {
        dialogCloseCallback: null,
        dialogLoopBackParams: null,
        layerIsDiv: false,
        //only accept message from here
        iframeLocation: null
    };

    //close type constants:
    //Close button outside the iframe was pressed
    var CLOSE_TYPE_FRAME = 1;
    //Close operation originated inside the iframe
    var CLOSE_TYPE_INNER = 2;
    //listen for this type of messages
    var CROSS_DOMAIN_MESSAGE_TYPE = 'diy.appUpsell.closeLayer';


    /**
     * creates the layer
     * @access private
     */
    var createLayer = function () {
        var layerContent = $((registry.layerIsDiv ? '<div>' : '<iframe>'));
        layerContent.addClass(config.selectors.layerClass);
        return layerContent;
    };
    /**
     * destroys the layer
     * @access private
     */
    var destroyLayer = function () {
        $('.' + config.selectors.layerClass)
            .remove();
    };

    /**
     * close layer operation
     * @access private
     */
    var closeLayer = function (closeType) {
        if (!layerIsOpen) {
            return;
        }

        $('.' + config.selectors.layerClass).diy_dialog('destroy');

        if (typeof registry.dialogCloseCallback === 'function') {
            if (registry.dialogLoopBackParams !== null) {
                registry.dialogCloseCallback(closeType, registry.dialogLoopBackParams);
            } else {
                registry.dialogCloseCallback(closeType);
            }
        }

        destroyLayer();
        detachMessageListener();
        layerIsOpen = false;
    };

    /**
     * Opens an upsell layer
     *
     * @access public
     *
     * @param iframeLocation
     * @param options see top of the file
     */
    var openLayer = function (iframeLocation, options) {
        if (layerIsOpen) {
            return false;
        }

        if (typeof iframeLocation !== 'string') {
            throw "openLayer: iframe location needs to be set as a string";
        }

        /*
         * remember some params because of closeLayer
         */
        if (options !== undefined
                && (typeof options.onClose === 'function')) {
            registry.dialogCloseCallback = options.onClose;
        } else {
            registry.dialogCloseCallback = null;
        }

        // decide to use a div instead of iframe
        if (options !== undefined && (options.layerIsDiv === true)) {
            registry.layerIsDiv = true;
        }

        /*
         * again remember some params because of closeLayer
         */
        if (options !== undefined && options.loopBackParams !== undefined) {
            registry.dialogLoopBackParams = options.loopBackParams;
        } else {
            registry.dialogLoopBackParams = null;
        }
        //remember the iframe location
        registry.iframeLocation = iframeLocation;


        var layerOptions = $.extend(true, {}, config.layerOptions);
        if (options !== undefined && options.layerOptions !== undefined) {
            layerOptions = $.extend(true, layerOptions, options.layerOptions);
        }

        if ((options !== undefined) && (typeof options.title === "string")) {
            layerOptions.title = options.title;
        }

        layerOptions = $.extend(true, layerOptions, config.immutableLayerOptions);

        //dialog close callback
        layerOptions.close = function () {
            closeLayer(CLOSE_TYPE_FRAME);
        };

        // create inner layer and build a dialog around it
        var layer = createLayer();
        if (!registry.layerIsDiv) {
            layer.attr('src', iframeLocation);
        }
        layer.diy_dialog(layerOptions);
        attachMessageListener();
        layerIsOpen = true;

        // expose the inner layer to the outside
        return layer;
    };

    /**
     * @access private
     */
    var attachMessageListener = function () {
        crossDomain.receiver.registerReceiver(
            CROSS_DOMAIN_MESSAGE_TYPE,
            innerFrameCloseHandler,
            registry.iframeLocation
        );
    };
    /**
     * When the dialog closes it detaches the message listener
     * @access private
     */
    var detachMessageListener = function () {
        crossDomain.receiver.unregisterReceiver(CROSS_DOMAIN_MESSAGE_TYPE);
    };

    /**
     * Handles the postMessage messages comming from inside the iframe itself
     */
    var innerFrameCloseHandler = function () {
        closeLayer(CLOSE_TYPE_INNER);
    };

//uncomment if need the init function
//    var init = function () {
//
//    };
//    //immediately call the init function
//    init(); //XXX: this runs before domReady

    //reveal
    $.extend(this, {
        openLayer: openLayer,
        closeLayer: closeLayer,
        CLOSE_TYPE_FRAME: CLOSE_TYPE_FRAME,
        CLOSE_TYPE_INNER: CLOSE_TYPE_INNER
    });

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/app-upsell/appUpsell.js
 ** module id = 727
 ** module chunks = 0
 **/